import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderLogReview.propTypes = {
  logItem: PropTypes.object,
}

export default function OrderLogReview({ logItem }) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      Order reviewed {logItem.reviewedBy ? `by ${logItem.reviewedBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}
